var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"detail-icon pinterest-link",attrs:{"href":_vm.href(),"target":"_blank","rel":"noopener"}},[_c('svg',[_c('use',{attrs:{"xlink:href":"#pinterest"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }